import React, { useEffect, useState } from 'react';
import { Routes, Route, Link, useNavigate } from 'react-router-dom';
import { useAuthStore } from '../context/store';
import api from '../utils/api';
import toast from 'react-hot-toast';

export default function Account() {
  return (
    <div style={{ minHeight: '100vh', background: '#F5F0E8', paddingTop: 80 }}>
      <div style={{ maxWidth: 900, margin: '0 auto', padding: '40px 24px' }}>
        <Routes>
          <Route index element={<AccountHome />} />
          <Route path="commandes" element={<MyOrders />} />
        </Routes>
      </div>
    </div>
  );
}

function AccountHome() {
  const { user, logout } = useAuthStore();
  const navigate = useNavigate();
  return (
    <div>
      <h1 style={{ fontFamily: 'Cormorant Garamond, Georgia, serif', fontWeight: 300, fontSize: 32, marginBottom: 32 }}>Mon compte</h1>
      <div style={{ background: 'white', borderRadius: 16, padding: 24, border: '1px solid #EAE3D6', marginBottom: 16 }}>
        <p style={{ fontWeight: 600, fontSize: 18, marginBottom: 4 }}>{user?.nom}</p>
        <p style={{ color: '#5C5A54', fontSize: 14 }}>{user?.email}</p>
        <p style={{ color: '#5C5A54', fontSize: 14 }}>{user?.telephone}</p>
      </div>
      <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
        <Link to="/compte/commandes" style={{ padding: '12px 24px', background: '#0F0E0C', color: '#C9A84C', borderRadius: 8, textDecoration: 'none', fontSize: 14, fontWeight: 600 }}>Mes commandes</Link>
        <button onClick={() => { logout(); navigate('/'); }} style={{ padding: '12px 24px', background: '#FDEDEC', color: '#C0392B', border: 'none', borderRadius: 8, fontSize: 14, fontWeight: 600, cursor: 'pointer' }}>Déconnexion</button>
      </div>
    </div>
  );
}

function MyOrders() {
  const [orders, setOrders] = useState([]);
  useEffect(() => {
    api.get('/orders').then(r => setOrders(r.data.orders || [])).catch(() => {});
  }, []);
  const statusLabel = { attente: 'En attente', confirme: 'Confirmé', preparation: 'En préparation', expedie: 'Expédié', livre: 'Livré', annule: 'Annulé' };
  return (
    <div>
      <Link to="/compte" style={{ color: '#C9A84C', fontSize: 13, textDecoration: 'none' }}>← Retour</Link>
      <h2 style={{ fontFamily: 'Cormorant Garamond, Georgia, serif', fontWeight: 300, fontSize: 28, margin: '16px 0 24px' }}>Mes commandes</h2>
      {orders.length === 0 ? (
        <div style={{ background: 'white', borderRadius: 16, padding: 40, textAlign: 'center', border: '1px solid #EAE3D6' }}>
          <p style={{ color: '#ABA89F', fontFamily: 'Cormorant Garamond, Georgia, serif', fontSize: 20, fontStyle: 'italic' }}>Aucune commande pour le moment</p>
          <Link to="/boutique" style={{ display: 'inline-block', marginTop: 16, padding: '12px 24px', background: '#0F0E0C', color: '#C9A84C', borderRadius: 8, textDecoration: 'none', fontSize: 14 }}>Explorer la boutique</Link>
        </div>
      ) : orders.map(o => (
        <div key={o.id} style={{ background: 'white', borderRadius: 12, padding: 20, border: '1px solid #EAE3D6', marginBottom: 12, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div>
            <p style={{ fontFamily: 'Space Mono, monospace', fontSize: 12, color: '#C9A84C', marginBottom: 4 }}>#{o.ref}</p>
            <p style={{ fontWeight: 600, fontSize: 16 }}>{parseInt(o.total).toLocaleString('fr-CI')} FCFA</p>
            <p style={{ fontSize: 12, color: '#5C5A54', marginTop: 4 }}>{new Date(o.created_at).toLocaleDateString('fr-FR')}</p>
          </div>
          <span style={{ background: '#F5F0E8', color: '#5C5A54', padding: '4px 12px', borderRadius: 20, fontSize: 12, fontFamily: 'Space Mono, monospace' }}>{statusLabel[o.statut] || o.statut}</span>
        </div>
      ))}
    </div>
  );
}
